import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Button, Card, CardContent, CollapseTrigger, EqualHeight, InternetSpeed, Separator, Text } from 'telia-front-react';
import { PLANNED_B2B_OFA_INTERNET_KEY } from '../../../stores/InternetCalculatorStore';
import { Segment } from '../../../stores/SegmentStore';
import { ProductCard } from '../InternetCalculatorInterfaces';

interface PlannedCardProps {
  card: ProductCard;
  partner: boolean;
  hideBetterInternetForms: boolean;
  segment: Segment;
  noEmptySpaceOnTop?: boolean;
}

const resolveDueDateDescription = (el: boolean, translate: (key: string, params?: any) => string, card: ProductCard) => {
  switch (card.timeline) {
    case 'EXACT_DATE':
      return translate(
        el ? 'internetAndTvCalculator.elektrileviPlannedNetwork.exactDateDescription' : 'internetAndTvCalculator.plannedNetwork.exactDateDescription',
        { speed: card.speed, date: card.date },
      );
    case 'UP_TO_FOUR_YEARS':
      return (
        <>
          {translate(
            el
              ? 'internetAndTvCalculator.elektrileviPlannedNetwork.upToFourYearsDescription'
              : 'internetAndTvCalculator.plannedNetwork.upToFourYearsDescription',
            { year: card.year },
          )}
        </>
      );
    default:
      return (
        <>
          {translate(
            el
              ? 'internetAndTvCalculator.elektrileviPlannedNetwork.longerThanFourYearsDescription'
              : 'internetAndTvCalculator.plannedNetwork.longerThanFourYearsDescription',
            { year: card.year },
          )}
        </>
      );
  }
};

function PlannedCard(props: PlannedCardProps): JSX.Element {
  const translate = React.useContext(TranslationsContext).translate;

  const { card } = props;
  const offerName = card.productOfferingCode.replace('/', '__');
  const downSpeed = translate(`internetAndTvCalculator.${offerName}.downSpeed`);
  const upSpeed = translate(`internetAndTvCalculator.${offerName}.upSpeed`);
  const isEqualSpeed = downSpeed && upSpeed && downSpeed === upSpeed;
  return (
    <>
      <Card type="light" background="neutral-bg-level-1" className="text-left" elevation={1}>
        <CardContent tagTop={props.noEmptySpaceOnTop ? null : true}>
          <Text>
            <EqualHeight group="internet-speed">
              <p className="text-small">{translate('internetAndTvCalculator.speedUpTo')}</p>
              <Separator color="invisible" spacing="xxsmall" />
              <InternetSpeed
                downSpeed={downSpeed}
                downUnit={{
                  unit: translate(`internetAndTvCalculator.${offerName}.downUnit`),
                  direction: translate('internetAndTvCalculator.direction.down'),
                }}
                upSpeed={upSpeed}
                upUnit={{
                  unit: translate(`internetAndTvCalculator.${offerName}.upUnit`),
                  direction: translate('internetAndTvCalculator.direction.up'),
                }}
                align={'left'}
                collapsed={isEqualSpeed}
                multiline={!isEqualSpeed}
              />
            </EqualHeight>
            <EqualHeight group="card-text">
              <p>{resolveDueDateDescription(props.partner, translate, card)}</p>
            </EqualHeight>
            <EqualHeight group="price">
              <div />
            </EqualHeight>
          </Text>
          <Separator color="invisible" spacing="small" weight="thin" />
          {!props.hideBetterInternetForms &&
            !(props.segment === 'BUSINESS' && props.partner && props.card.productOfferingCode !== PLANNED_B2B_OFA_INTERNET_KEY) && (
              <AnalyticsTrigger
                trigger={{
                  id: 'CTA - Form - Enefit sooviavaldus',
                  callback: 'onToggle',
                }}
              >
                <CollapseTrigger>
                  <Button className="text__margin-double" text={translate('internetAndTvCalculator.willVote')} block variant="secondary" />
                </CollapseTrigger>
              </AnalyticsTrigger>
            )}
        </CardContent>
      </Card>
    </>
  );
}

export default observer(PlannedCard);
